export const setActiveRegion = id => {
  return {
    type: 'REGION:SET_ACTIVE',
    payload: { id },
  };
};

export const setComparedRegion = id => {
  return {
    type: 'REGION:SET_COMPARED',
    payload: { id },
  };
};

export const setActiveEntity = id => {
  return {
    type: 'ENTITY:SET_ACTIVE',
    payload: { id },
  };
};

export const setComparedEntity = id => {
  return {
    type: 'ENTITY:SET_COMPARED',
    payload: { id },
  };
};

export const setActivePage = name => {
  return {
    type: 'PAGE:SET_ACTIVE',
    payload: { name },
  };
};
export const setIsMobile = isMobile => {
  return {
    type: 'SET_IS_MOBILE',
    payload: isMobile,
  };
};



// WEBPACK FOOTER //
// ./src/actions/ui.js